import React, { FC } from 'react'

import { EuiLink, EuiText } from '@elastic/eui'
import { _EuiSideNavItemButtonProps, _EuiSideNavItemProps } from '@elastic/eui/src/components/side_nav/side_nav_item'

export interface ISubNavItem extends Omit<_EuiSideNavItemButtonProps, 'children'>, Omit<_EuiSideNavItemProps, 'isParent' | 'depth' | 'isOpen' | 'childrenOnly'> {
  isSelected?: boolean
}

export const SubNavItem: FC<ISubNavItem> = props => {
  return (
    <span className={'euiSideNavItemButton'}>
      <EuiLink onClick={props.onClick} style={{ marginTop: '2px', marginBottom: '2px', paddingLeft: '10px' }}>
        <EuiText size={'s'} className={`euiSideNavItemButton euiSideNavItemButton__label ${props.isSelected ? 'euiSideNavItemButton-isSelected' : ''}`}>
          {props.children}
        </EuiText>
      </EuiLink>
    </span>
  )
}
